import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import * as amplitude from 'amplitude-js';
import { User, LoginCredentials } from '@/interfaces';
import { UserDTO, LoginResponseDTO, RoleDTO } from '@/api';
import services from '@/services';
import { getAuthToken, setAuthToken, unsetAuthToken } from '@/utils';
import { AxiosResponse } from 'axios';

@Module({ name: 'AuthModule' })
export default class AuthModule extends VuexModule {
  whoIam: User | null = null;

  roles: RoleDTO[] = [];

  get hasAuthIdentification() {
    return !!getAuthToken();
  }

  get hasAuthentication() {
    return !!(this.whoIam && this.whoIam.id != null);
  }

  get permissions() {
    const permissions = this.roles.flatMap(role => role.permissions);
    return [...new Set(permissions.map(p => p?.id as string))];
  }

  @Mutation
  SET_USER(user: User) {
    this.whoIam = user;
  }

  @Mutation
  setRoles(roles: RoleDTO[]) {
    this.roles = roles;
  }

  @Action({ rawError: true })
  async tryToLogin(credentials: LoginCredentials) {
    try {
      const { login, password } = credentials;
      const { data: { token } }: AxiosResponse<LoginResponseDTO> = await services.userService()
        .loginEndpointLogin(login, password);
      if (!token) throw Error('Что-то пошло не так с ответом сервера');
      setAuthToken(token);
      const { data: authorities } = await services.userService().userEndpointGetUserCredentials();
      this.setRoles(authorities);
      return this.syncMe();
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  }

  @Action
  async syncMe() {
    try {
      const { data }: { data: UserDTO } = await services.userService().userEndpointGetCurrentUser();
      this.context.commit('SET_USER', data);
      const { data: authorities } = await services.userService().userEndpointGetUserCredentials();
      this.setRoles(authorities);
      amplitude.getInstance().init('3afe01e1630fd63b01a8c2064614d8f2', String(data.id));
      // const amplitudeClient = new amplitude.AmplitudeClient();
      // amplitudeClient.logEvent('login', data);
      amplitude.getInstance().setUserProperties({
        name: `${data.firstName} ${data.surname}`,
        authorities,
      });
      amplitude.getInstance().logEvent('login', data);

      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return Promise.reject(error);
    }
  }

  @Action
  async logout() {
    try {
      await services.userService().loginEndpointLogout();
      unsetAuthToken();
      this.context.commit('SET_USER', null);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
